import axios from "axios";
import { getToken as getAppCheckToken } from "firebase/app-check";
import { appCheck } from "../../firebase";
import { environment } from "../../config/enviroment";

const generateJobDescription = async (
  industry: string,
  tone: string,
  jobTitle: string,
  companyName: string,
  location: string
) => {
  try {
    const appCheckToken = await getAppCheckToken(appCheck);
    const response = await axios.post(
      `${environment.endpoints.generateJobDescription}`,
      {
        industry,
        tone,
        jobTitle,
        companyName,
        location,
      },
      {
        headers: {
          "X-Firebase-AppCheck": appCheckToken.token,
        },
      }
    );
    console.log(response.data);
    return {
      message: "Job description generated successfully",
      success: true,
      result: response.data.result,
    };
  } catch (error) {
    console.error(error);
    return { message: "Error generating job description", success: false };
  }
};

export default generateJobDescription;
